import { PublicClientApplication } from "@azure/msal-browser";

export const msalInstance = new PublicClientApplication({
  auth: {
    clientId: process.env.AAD_CLIENT_ID || "",
    authority: "https://login.microsoftonline.com/a289d6c2-3b1f-4bc4-8fa0-6866ff300052",
    redirectUri: process.env.AAD_REDIRECT_URI,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: true,
  },
});
